import React from 'react';
import { Typography, Button, InfoItem, FlagIcon, Pagination } from '../../design-system';
import {
  DashboardHeader,
  DashboardFormCards,
  DashboardFormCard,
  DashboardFormCardRows,
  DashboardFormCardsFooter,
} from '../dashboard';
import { useStore } from '../../context';
import { momentTextFormat, scrollFromToAnimation } from '../../utils';
import { UserVisitGetOneQuery } from '../../types';
import { i18n } from '../../i18n';
import { usePaginationState } from '../../hooks';
import { TABLE } from '../../const';

export const UserVisitsViewHeader = ({ data, totalCount }: UserVisitGetOneQuery) => {
  const clientCode = data[0].clientCode ? data[0].clientCode + ' ' : '';

  return (
    <DashboardHeader id={'user-visit-view-header'}>
      <Typography variant={'textXL'} weight={'bold'}>
        {clientCode}
        {data[0].user.firstName} {data[0].user.lastName}: {data[0].role} - {totalCount}{' '}
        {i18n.t('pages.userVisitsView.title')}
      </Typography>
      <Button size={'medium'} data-color={'white'} to={-1}>
        {i18n.t('button.goBack')}
      </Button>
    </DashboardHeader>
  );
};

export const UserVisitsViewForm = ({ data }: UserVisitGetOneQuery) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  const { page, take, skip, handlePageChange } = usePaginationState();

  const handleOnPageChange = (e: any, page: number) => {
    scrollFromToAnimation('dashboard-main', 'user-visit-view-header', 100);
    handlePageChange(e, page);
  };

  return (
    <DashboardFormCards>
      {data.slice(skip, skip + take).map((item, i) => (
        <React.Fragment key={i}>
          <DashboardFormCardRows>
            <DashboardFormCard paperSize={'full-size'}>
              <Typography variant={'textL'} weight={'semibold'} color={'--gray-90'}>
                {i18n.t('common.generalInformation')}
              </Typography>
              <InfoItem label={i18n.t('label.device')} value={item.deviceName} size={'small'} />
              <InfoItem
                label={i18n.t('label.country')}
                startAdornment={<FlagIcon countryCode={item.countryCode} />}
                value={item.country}
                size={'small'}
              />
              <InfoItem label={i18n.t('label.ip')} value={item.ip} size={'small'} />
            </DashboardFormCard>
          </DashboardFormCardRows>
          <DashboardFormCardRows>
            <DashboardFormCard paperSize={'full-size'}>
              <Typography variant={'textL'} weight={'semibold'} color={'--gray-90'}>
                {momentTextFormat(item.createdAt, user)} -{' '}
                {momentTextFormat(item.lastVisitedAt, user)}
              </Typography>
              {item.actions.map((action, i) => (
                <InfoItem
                  key={i}
                  label={action?.actionName || i18n.t('label.chip.online')}
                  value={momentTextFormat(action?.createdAt, user)}
                  size={'small'}
                />
              ))}
            </DashboardFormCard>
          </DashboardFormCardRows>
        </React.Fragment>
      ))}
      <DashboardFormCardsFooter>
        <Pagination
          count={Math.ceil(data.length / TABLE.PAGE_MAX_SIZE)}
          page={page}
          onChange={handleOnPageChange}
        />
      </DashboardFormCardsFooter>
    </DashboardFormCards>
  );
};
